export class AlertModal {
    private _modalType: string;
    private _header: string;
    private _content: string;
    private _footerPrimaryBtnLabel: string;
    private _footerSecondaryBtnLabel: string;
    private _checkMessage: string;

    constructor(
        modalType: string,
        header: string,
        content: string,
        footerPrimaryBtnLabel: string = 'OK',
        footerSecondaryBtnLabel: string = '',
        checkMessage: string
    ) {
        this._modalType = modalType;
        this._header = header;
        this._content = content;
        this._footerPrimaryBtnLabel = footerPrimaryBtnLabel;
        this._footerSecondaryBtnLabel = footerSecondaryBtnLabel;
        this._checkMessage = checkMessage;
    }

    /**
     * Getter header
     */
    public get header(): string {
        return this._header;
    }

    /**
     * Getter content
     */
    public get content(): string {
        return this._content;
    }


    public setContent(content) {
        this._content = content;
    }
    public setHeader(header) {
        this._header = header;
    }

    /**
     * Getter footerPrimaryBtnLabel
     */
    public get footerPrimaryBtnLabel(): string {
        return this._footerPrimaryBtnLabel;
    }

    /**
     * Getter footerSecondaryBtnLabel
     */
    public get footerSecondaryBtnLabel(): string {
        return this._footerSecondaryBtnLabel;
    }

    /**
     * Getter modalType
     */
    public get modalType(): string {
        return this._modalType;
    }

    /**
     * Getter checkMessage
     */
    public get checkMessage(): string {
        return this._checkMessage;
    }
}
